module.exports = __webpack_public_path__ + "6362c6ab70679a94b1d21eacb82d060b.svg";